
export function validateInputs(form, toast, translate) {
    for (const [key, value] of Object.entries(form)) {
        if (isEmpty(value)) {
            toast.error(translate(`web.theField`, `The field`) + " " + translate(`web.${(key)}`, key) + " " + translate(`web.isrequired`, 'Is Required'))
            return false;
        }
    }
    return true;
}

export function isEmpty(value) {
    // null or undefined
    if (value === null || value === undefined) return true;

    // strings
    if (typeof value === "string") {
        return value.trim().length === 0;
    }

    // arrays
    if (Array.isArray(value)) {
        return value.length === 0;
    }

    // objects
    if (typeof value === "object") {
        return Object.keys(value).length === 0;
    }

    // numbers, booleans, functions, symbols → not empty
    return false;
}


/**
 * let keyTranslationsMap = new Map();
 * keyTranslationsMap.set('CountryId', { errorMessage: translate('web.countryName', 'countryName'), condition: (value, formData, key) => isEmpty(value) })
 */
const validate = (data, keyTranslationsMap, toast, translate) => {
    const theField = `${translate('web.theField', 'The Field')} `;
    const isrequired = ` ${translate('web.isRequired', 'Is Required')}`;
    for (let key in data) {
        const validation = keyTranslationsMap.get(key);
        if (validation.condition(data[key], data, key)) {
            toast.error(theField + validation.errorMessage + isrequired);
            return false;
        }
    }
    return true;
}

// use
// if (validate(qualificationObj, keyTranslationsMap)) {

// }